import React from "react";
import { Modal, Button, Typography, message } from "antd";
import { deletePost } from "../useAPIDetails/usePostRelatedAPI";
const { Text } = Typography;

const DeletePostModal = ({ isModalVisible, setIsModalVisible, postId }) => {
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleConfirm = async() => {
    setIsModalVisible(false);
    try{
    const response = await deletePost(postId);
    message.success(response?.message);
    } catch (error) {
      message.error(error?.response?.data?.message || "Something went wrong in deleting the post.");
    }
  };

  return (
    <Modal
      title="Confirm Deletion"
      open={isModalVisible}
      onCancel={handleCancel}
      centered
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="delete" type="primary" danger onClick={handleConfirm}>
          Delete
        </Button>,
      ]}
    >
      <Text>
        Are you sure you want to delete the post{" "}
        <Text strong>postid {postId}</Text>?
      </Text>
    </Modal>
  );
};

export default DeletePostModal;
